<div class="help-page">
  <div class="title">Das WettArena Support-Formular</div>

  <div class="help-text">
    Bei Fragen und Anliegen helfen wir Ihnen gerne persönlich weiter. Fülle dazu einfach unser Support-Formular aus oder schreibe eine Nachricht an support@ibc-betting.com. Wir
    melden uns schnellstmöglich bei dir.
  </div>

  <form class="help-login-form" [formGroup]="loginDatas">
    <inputb3 formControlName="userName" [fID]="'user_name'" fPlaceholder="{{ 'user_name' | t }}" fInputType="text" fErrorText="{{ 'Required' | t }}"></inputb3>
    <inputb3
      formControlName="email"
      [fID]="'e_mail_address'"
      fPlaceholder="{{ 'e_mail_address' | t }}"
      fInputType="email"
      fErrorText="{{
        loginDatas.controls?.email?.errors?.required ? ('Required' | t) : loginDatas.controls?.email?.errors?.email ? ('Please_enter_a_valid_mail_address' | t) : ''
      }}"></inputb3>
    <dropdownb3
      [fData]="categoryList"
      [fDataValueKey]="'id'"
      [fDataViewKey]="'value'"
      fDefaultSelectText=" {{ 'help_category' | t }}"
      formControlName="category"
      fErrorText=""></dropdownb3>
    <dropdownb3
      [fData]="problemList"
      [fDataValueKey]="'id'"
      [fDataViewKey]="'value'"
      fDefaultSelectText=" {{ 'help_problem' | t }}"
      formControlName="problem"
      fErrorText=""></dropdownb3>
    <textareab3 formControlName="message" [fID]="'help_message'" fPlaceholder="{{ 'help_message' | t }}" class="help-textarea" fErrorText="{{ 'Required' | t }}"></textareab3>
    <div class="submit-wrap btn-yellow" (click)="SendMessage()">
      <button [disabled]="!loginDatas?.valid" type="submit" id="submitBtnCheck" class="buttonSuccess btn-yellow">
        {{ 'help_send_button' | t }}
      </button>
    </div>
  </form>
</div>
